// GlobalStyle.js
import { createGlobalStyle } from "styled-components";

import CalendarIcon from "assets/images/etc/icon_calendar_month.svg";

// 스타일 초기화
export const GlobalStyle = createGlobalStyle`
    * {
      margin: 0;
      padding: 0;
      vertical-align: baseline;
      font-family:
        "Pretendard Variable",
        Pretendard,
        -apple-system,
        BlinkMacSystemFont,
        system-ui,
        Roboto,
        "Helvetica Neue",
        "Segoe UI",
        "Apple SD Gothic Neo",
        "Noto Sans KR",
        "Malgun Gothic",
        "Apple Color Emoji",
        "Segoe UI Emoji",
        "Segoe UI Symbol",
        sans-serif;
      -webkit-box-sizing: border-box; /* Safari, Chrome, other WebKit */
      -moz-box-sizing: border-box;    /* Firefox, other Gecko */
      box-sizing: border-box;         /* Opera, IE 8+ */
      -webkit-text-size-adjust: 100%; /* iOS Safari 자동 확대 방지 */
      }

  body {
    overflow-x: hidden;
  }

  html {
    width: 100%;
    height: 100%;
    scrollBar.default-width: thin;
    scroll-behavior: smooth;
  }
  body {
    overflow: hidden auto;
  }
  html, body {
    height: 100%;
    line-height: 1.5;
    font-weight: 400;
    color: #222222;
    width: 100%;
    min-width: 100vw; 
    /* overflow-x: hidden; */

  }
  h4 {
    font-size: 24px;
  }
  button {
    border: 0;
    background: transparent;
    cursor: pointer;
  }
  a {
    color: ${({ theme }) => theme.color.gray650};
    text-decoration: none;
    cursor: pointer;

    &:link,
    &:hover,
    &:active,
    &:visited {
      text-decoration: none;
    }
  }
  a, ol, p, table, ul, dl {
    list-style: none;
    z-index: 1;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: none;
  }
  em, i, address {
    font-style: normal;
    font-weight: normal;
  }
  table {
    border-spacing: 0;
    border-collapse: collapse;
  }
  img, fieldset {
    border: 0;
  }
  legend, caption {
    display: none;
  }
  textarea {
    resize: none;
  }
  textarea, input {
    -webkit-border-raidus: 1px;
    -mox-border-radius: 1px;
    border-radius: 1px;
    outline: 0;
    border: 0;
  }
  input {
    height: 36px;

    &::placeholder {
      color: ${({ theme }) => theme.color.gray300};
      font-size: 12px;
      font-weight: 300;
    }

  &[type="date"] {
    position: relative;
    background: url(${CalendarIcon}) left 12px center no-repeat;
    background-size: 20px;
    padding-left: 40px;

    /* 캘린더 선택 영역 전체로 변경 */
    ::-webkit-calendar-picker-indicator {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: transparent;
      color: transparent;
      cursor: pointer;
    }
  }
  }
`;
